export default __webpack_public_path__ + "static/logo-07ffd2be76afaa783a1891b33dbbf96c.png";